import Card from "components/card";
import React, { useEffect, useState } from "react";
import TimeLine from "./Time_line";
import {
  Dialog,
  DialogHeader,
  DialogBody,
} from "@material-tailwind/react";

import { getAllTcpsApi } from "api/filtersData";
import { getTimeLineDataApi } from "api/timeLine";

function TcpTable() {
  const [showTimelineModal, setShowTimelineModal] = useState(false)
  const [listOfTcp, setListOfTcp] = useState([])

  const [selectedTcp, setSelectedTcp] = useState("")
  const [selectedTcpName, setSelectedTcpName] = useState("")
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear())
  const [operationType, setOperationType] = useState("all")
  const [stoppedStep, setStoppedStep] = useState("all")

  const [timeLineData, setTimeLineData] = useState([])

  const isStoppedAtStep = (entry, step) => {
    if (step === "all") return true;

    // Pré commande: not yet validated by either Directeur Général or Directeur Commercial
    if (step === "PreCommande") {
      return entry.EtatDgeneral !== "V" && entry.Dcommercial !== "V";
    }

    // Validation DG/DC: validated by Directeur Général or Directeur Commercial,
    // but not yet progressed to Magasinier (Vente) or Facturation (Recouvrement)
    if (step === "EtatCommercial") {
      const dgDcValidated =
        entry.EtatDgeneral === "V" || entry.Dcommercial === "V";
      return (
        dgDcValidated &&
        entry.EtatMagasinier !== "V" &&
        entry.EtatFacturation !== "V"
      );
    }

    const steps = [
      "EtatCommercial",
      "EtatMagasinier",
      "EtatFacturation",
      "EtatMagasinierTwo",
      "EtatSuccess",
    ];

    const idx = steps.indexOf(step);
    if (idx === -1) return true;

    const current = entry[step];
    const next = steps[idx + 1] ? entry[steps[idx + 1]] : null;

    // show only if current is validated AND the next step is not yet validated
    return current === "V" && next !== "V";
  };

  useEffect(() => {
    getInitialData()
  }, [])

  const getInitialData = async () => {
    try {
      const response = await getAllTcpsApi()
      setListOfTcp(response)

      console.log(response)
    }
    catch (err) {
      console.log(err)
    }
  }

  const handleShowTcpTimeLine = async (tcp) => {
    try {
      setShowTimelineModal(!showTimelineModal)

      if (!tcp || !tcp._id) return;

      setSelectedTcp(tcp._id)
      setSelectedTcpName(tcp.Name)

      const filtredData = {
        opID: tcp._id,
        getFullYear: selectedYear
      }
      const response = await getTimeLineDataApi(filtredData)
      setTimeLineData(response)
    } catch (err) {
      console.log(err);
    }
  };

  const handleYearChange = async (year) => {
    setSelectedYear(year)
    if (!selectedTcp) return;
    try {
      const response = await getTimeLineDataApi({ opID: selectedTcp, getFullYear: year })
      setTimeLineData(response)
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {/* <Popup ref={popupRef} modal nested>
        {(close) => (
          <div className="modal rounded-[20px]">
            <div className="">
              <TimeLine />
              <TimeLine />
              <TimeLine />
              <TimeLine />
              <TimeLine />
              <TimeLine />
            </div>
          </div>
        )}
      </Popup> */}

      <Dialog
        size="xl"
        open={showTimelineModal}
        handler={handleShowTcpTimeLine}
      >
        <DialogHeader>
          <div className="w-full flex flex-col gap-2">
            {selectedTcpName && (
              <p className="w-full text-center text-lg font-bold text-navy-700">
                {selectedTcpName}
              </p>
            )}
            <p className="w-full text-center">Historique des opérations</p>
            <div className="flex flex-wrap items-center justify-center gap-3 text-sm">
              <div className="flex items-center gap-2">
                <span className="text-gray-600">Année :</span>
                <select
                  value={selectedYear}
                  onChange={(e) => handleYearChange(Number(e.target.value))}
                  className="border border-gray-300 rounded-md px-2 py-1 text-sm bg-white dark:bg-navy-700 dark:text-white"
                >
                  {Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i).map((year) => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-gray-600">Type :</span>
                <select
                  value={operationType}
                  onChange={(e) => setOperationType(e.target.value)}
                  className="border border-gray-300 rounded-md px-2 py-1 text-sm bg-white dark:bg-navy-700 dark:text-white"
                >
                  <option value="all">Tous</option>
                  <option value="Vente">Vente</option>
                  <option value="Avoir">Avoir</option>
                  <option value="Recouvrement">Recouvrement</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-gray-600">Étape atteinte :</span>
                <select
                  value={stoppedStep}
                  onChange={(e) => setStoppedStep(e.target.value)}
                  className="border border-gray-300 rounded-md px-2 py-1 text-sm bg-white dark:bg-navy-700 dark:text-white"
                >
                  <option value="all">Toutes</option>
                  <option value="PreCommande">Pre commande</option>
                  <option value="EtatCommercial">Bon de commande</option>
                  <option value="EtatMagasinier">Bon de livraison</option>
                  <option value="EtatFacturation">Facture / Avoir</option>
                  <option value="EtatMagasinierTwo">Rapport après facturation</option>
                  <option value="EtatSuccess">Livré</option>
                </select>
              </div>
            </div>
          </div>
        </DialogHeader>
        <DialogBody className="h-[80vh] overflow-scroll">
          {
            timeLineData
              .filter(el => operationType === "all" ? true : el.ModeOperation === operationType)
              .filter(el => isStoppedAtStep(el, stoppedStep))
              .map((el, idx) => (
              <TimeLine key={`${el._id || idx}`} TimeLineData={el} />
            ))
          }
        </DialogBody>
      </Dialog>

      <Card extra={"w-full pb-10 p-4 h-full"}>
        <header className="relative flex items-center justify-between">
          <div className="text-xl font-bold text-navy-700 dark:text-white"></div>
        </header>
        <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
          <table className="w-full">
            <thead>
              <tr>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">TCP</p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">E-mail</p>
                </th>
              </tr>
            </thead>

            <tbody>
              {
                listOfTcp.map(el => (
                  <tr
                  onClick={() => handleShowTcpTimeLine(el)}
                  className="cursor-pointer hover:bg-gray-100 dark:hover:bg-navy-900"
                >
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {
                        el.Name
                      }
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {
                        el.Email
                      }
                    </p>
                  </td>
                </tr>
                ))
              }
            </tbody>
          </table>
        </div>
    </Card>
    </>
  );
}

export default TcpTable;
